import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '@/pages/Homepage'

// 展览
import Exhibitioninfo from '@/pages/Exhibitioninfo'
import Exchange from '@/pages/exhibitioninfo/exchange'
import Permanent from '@/pages/exhibitioninfo/permanent'
import Thematic from '@/pages/exhibitioninfo/thematic'
import Shuzivr from '@/pages/exhibitioninfo/vr'
import Micro from '@/pages/exhibitioninfo/micro'
import ExchangeDetials from '@/pages/exhibitioninfoDetials/exchangeDetials'
import PermanentDetials from '@/pages/exhibitioninfoDetials/permanentDetials'
import ThematicDetials from '@/pages/exhibitioninfoDetials/thematicDetials'
import MicroDetials from '@/pages/exhibitioninfoDetials/microDetials'

//馆藏
import Collection from '@/pages/Collection'
import Paper from '@/pages/collection/paper'
import Goldsilver from '@/pages/collection/goldsilver'
import Jade from '@/pages/collection/jade'
import Copper from '@/pages/collection/copper'
import Ceramics from '@/pages/collection/ceramics'
import Painting from '@/pages/collection/painting'
import Clothes from '@/pages/collection/clothes'
import Cloth from '@/pages/collection/cloth'

//关于
import Aboutqb from '@/pages/Aboutqb'
import Volunteer from '@/pages/about/volunteer'
import Sjactivity from '@/pages/about/sjactivity'
import Introduction from '@/pages/about/introduction'
import Organization from '@/pages/about/organization'
import Qbconstitution from '@/pages/about/qbconstitution'
import Tourguide from '@/pages/about/tourguide'
import Talent from '@/pages/about/talent'
import Contact from '@/pages/about/contact'
import Volunbm from '@/pages/about/volunteer/volunbm'
import Volunxz from '@/pages/about/volunteer/volunxz'
import Volun from '@/pages/about/volunteer/volun'
import Activity from '@/pages/about/sjactivity/activity'
import 	Talentdetials from '@/pages/about/talentdetials/talentdetials'
import Activitybm from '@/pages/about/sjactivity/acticitybm'
import ActivityDetials from '@/pages/about/sjactivity/activityDetials'

//资讯
import Informations from '@/pages/Informations'
import Qbdynamic from '@/pages/informations/qbdynamic'
import Qbnews from '@/pages/informations/qbnews'
import Inner from '@/pages/Informations/inner'
import Bzhjs from '@/pages/informations/bzhjs'
import InnerDetials from '@/pages/informationsDetials/innerDetials'
import Learning from '@/pages/academic/learning'
import NewsDetials from '@/pages/informationsDetials/newsDetials'
import DynamicDetials from '@/pages/informationsDetials/dynamicDetials'
import LearningDetials from '@/pages/academic/learningDetials'
import BzhDetials from '@/pages/informationsDetials/bzhDetials'
import Closure from '@/pages/informationsDetials/closure'

//文创
import Wenchuang from '@/pages/Wenchuang'
import WenchuangDetials from '@/pages/wenchuangDetials'

import CulturalDetials from '@/pages/CulturalDetials'


import Social from '@/pages/Social'
import Forum from '@/pages/Social/forum'
import Ldmuseum from '@/pages/Social/ldmuseum'
import Team from '@/pages/Social/team'
import Forumbm from '@/pages/Social/forumbm'
import Vr from '@/pages/vr'
import Explain from '@/pages/Social/explain'
import ExplainDetials from '@/pages/Social/explainDetials'
import Flowmuseum from '@/pages/Social/flowmuseum'
import FlowmuseumDetials from '@/pages/Social/flowmuseumDetials'
import ForumDetials from '@/pages/Social/forumDetials'
import CollectionDetials from '@/pages/collectionDetials/collectionDetials'

import Academic from '@/pages/academic'

import Wprotect from '@/pages/academic/wprotect'
import WprotectDetials from '@/pages/academic/wprotectDetials'

Vue.use(Router)

export default new Router({
	scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/Homepage',
      name: 'Homepage',
      component: Homepage
    },
    {
      path: '/Exhibitioninfo',
      name: '展览',
      component: Exhibitioninfo,
      redirect: '/exhibitioninfo/permanent',
      children: [
      	{path: '/exhibitioninfo/exchange', component: Exchange, name: '展览交流', menuShow: true},
      	{path: '/exhibitioninfo/permanent', component: Permanent, name: '常设展览', menuShow: true},
      	{path: '/exhibitioninfo/thematic', component: Thematic, name: '专题展览', menuShow: true},
      	{path: '/exhibitioninfo/vr', component: Shuzivr, name: '数字展览', menuShow: true},
        {path: '/exhibitioninfo/micro', component: Micro, name: '微展览', menuShow: true}
      ]
    },
    {
      path: '/exhibitioninfoDetials/microDetials',
      name: '展览详情',
      component: MicroDetials
    },
    {
      path: '/exhibitioninfoDetials/exchangeDetials',
      name: '展览详情',
      component: ExchangeDetials
    },
    {
      path: '/exhibitioninfoDetials/permanentDetials',
      name: '展览详情',
      component: PermanentDetials
    },
    {
      path: '/exhibitioninfoDetials/thematicDetials',
      name: '展览详情',
      component: ThematicDetials
    },
        {
      path: '/Collection',
      name: 'Collection',
      component: Collection,
    },
    {
    	path: '/collection/goldsilver',
    	component: Goldsilver,
    },
    {
    	path: '/collection/jade',
    	component: Jade,
    },
    {
    	path: '/collection/copper',
    	component: Copper,
    },
    {
    	path: '/collection/ceramics',
    	component: Ceramics,
    },
    {
    	path: '/collection/painting',
    	component: Painting,
    },
    {
    	path: '/collection/clothes',
    	component: Clothes,
    },
     {
    	path: '/collection/cloth',
    	component: Cloth,
    },
  	{
  		path: '/collection/paper',
  		component: Paper,
  		menuShow: true,
  	},
    {
      path: '/Aboutqb',
      name: 'Aboutqb',
      component: Aboutqb,
      redirect: '/about/introduction',
      children: [
      	{path: '/about/introduction', component: Introduction, name: '青博介绍', menuShow: true},
      	{path: '/about/qbconstitution', component: Qbconstitution, name: '青博章程', menuShow: true},
      	{path: '/about/organization', component: Organization, name: '组织机构', menuShow: true},
        {path: '/about/talent', component: Talent, name: '人才招聘', menuShow: true},
        {path: '/about/contact', component: Contact, name: '联系我们', menuShow: true},
        {path: '/about/tourguide', component: Tourguide, name: '导览须知', menuShow: true},
      ]
    },
    {
      path: '/Informations',
      name: '资讯',
      component: Informations,
      redirect: '/informations/qbdynamic',
      children: [
      	{path: '/informations/qbdynamic', component: Qbdynamic, name: '青博动态', menuShow: true},
      	{path: '/informations/qbnews', component: Qbnews, name: '青博要闻', menuShow: true},
      	{path: '/informations/inner', component: Inner, name: '党内建设', menuShow: true},
        {path: '/informations/bzhjs', component: Bzhjs, name: '标准化建设', menuShow: true},
      ]
    },
    {
      path: '/informationsDetials/dynamicDetials',
      name: '青博动态',
      component: DynamicDetials
    },
    {
      path: '/informationsDetials/newsDetials',
      name: '青博要闻',
      component: NewsDetials
    },
    {
      path: '/informationsDetials/bzhDetials',
      name: '标准化建设',
      component: BzhDetials
    },
    {
      path: '/informationsDetials/closure',
      name: 'Closure',
      component: Closure
    },
    {
      path: '/informationsDetials/innerDetials',
      name: '党内建设',
      component: InnerDetials
    },
    {
      path: '/academic/learningDetials',
      name: '学术研究',
      component: LearningDetials
    },
    {
      path: '/Wenchuang',
      name: '文创',
      component: Wenchuang
    },
    {
      path: '/wenchuangDetials',
      name: '文创详情',
      component: WenchuangDetials
    },
    {
      path: '/CulturalDetials',
      name: 'CulturalDetials',
      component: CulturalDetials
    },
    {
      path: '/about/talentdetials/talentdetials',
      name: 'Talentdetials',
      component: Talentdetials
    },
    {
      path: '/Social',
      component: Social,
      redirect: '/Social/forum',
      children: [
      	{path: '/Social/forum', component: Forum, name: '青博名家讲堂', menuShow: true},
      	{path: '/Social/ldmuseum', component: Ldmuseum, name: '青博要闻', menuShow: true},
      	{path: '/Social/explain', component: Explain, name: '讲解队伍建设', menuShow: true},
      	{path: '/about/sjactivity/activity', component: Activity, name: '活动预约', menuShow: true},
      	{path: '/Social/flowmuseum', component: Flowmuseum, name: '流动博物馆', menuShow: true},
      	{
        	path: '/about/volunteer',
        	component: Volunteer,
        	name: '志愿者',
        	menuShow: true,
        	redirect: '/about/volunteer/volunbm',
		      children:[
		        {
		        	path: 'volunbm',
		        	component: Volunbm
		        },
		        {
		        	path: 'volunxz',
		        	component: Volunxz
		        },
		        {
		        	path: 'volun',
		        	component: Volun
		        }
		      ]
        },
      ]
    },
    {
      path: '/about/sjactivity/activitybm',
      name: '预约报名',
      component: Activitybm
    },
    {
      path: '/Social/forumbm',
      component: Forumbm
    },
    {
      path: '/Social/explainDetials',
      component: ExplainDetials
    },
    {
      path: '/Social/flowmuseumDetials',
      component: FlowmuseumDetials
    },
    {
      path: '/collectionDetials/collectionDetials',
      component: CollectionDetials
    },
    {
      path: '/Social/forumDetials',
      component: ForumDetials
    },
    {
      path: '/about/sjactivity/activityDetials',
      component: ActivityDetials
    },
    {
      path: '/academic',
      component: Academic,
      redirect: '/academic/learning',
      children: [
	        {
		    	path: '/academic/learning',
			    component: Learning,
			    menuShow: true
			},
		    {
			    path: '/academic/wprotect',
			    component: Wprotect,
			    menuShow: true
		    }
      ]
    },
    {
      path: '/academic/wprotectDetials',
      component: WprotectDetials
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js